import service from '@/utils/server';
let model = '/fm/fmUser/'
export const queryList = data => {
  return service({
    url: model+'pageInfo',
    method: 'post',
    data
  })
};

export const saveObject = data => {
  return service({
    url: model+'add',
    method: 'post',
    data
  })
};

export const updateObject = data => {
  return service({
    url: model+'update',
    method: 'post',
    data
  })
};

//
export const getAllRoleList = data => {
  return service({
    url: model+'getAllRoleList/'+data.clientId,
    method: 'post'
  })
};

//
export const getResetRoleList = data => {
  return service({
    url: model+'updateUserRoleInfo',
    method: 'post',
    data
  })
};

//
export const getResetPwd = data => {
  return service({
    url: model+'resetPwd',
    method: 'post',
    data
  })
};
export const getForceResetPwd = data => {
  return service({
    url: model+'forceResetPwd',
    method: 'post',
    data
  })
};
export const getDeleteUserList = data => {
  return service({
    url: model+'delete/'+data.userId,
    method: 'post'
  })
};
//rdc
export const getAllRdcList = data => {
  return service({
    url: model+'getAllRdcList/'+data.clientId,
    method: 'post'
  })
};

//carrier
export const getAllCarrierList = data => {
  return service({
    url: model+'getAllCarrierList/'+data.clientId,
    method: 'post'
  })
};


//userType
export const listUserType = data => {
  return service({
    url: model+'userType/'+data.clientId,
    method: 'post'
  })
};

//分配角色初始化话权限数据
export const initRolePrivilegeData = data => {
  return service({
    url: model+'initUserRoleData/' + data.userId,
    method: 'post'
  })
};

//
export const initAllCounterList = data => {
  return service({
    url: model+'initAllCounterList',
    method: 'post',
    data
  })
};
//微信账号解绑
export const unbindWx = data => {
  return service({
    url: model+'unbindWx',
    method: 'post',
    data
  })
};

//导入方法
export const userUpLoad = data => {
  let config = {
    responseType: "blob",
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return service({
    ...config,
    url: model + 'userUpload',
    method: 'post',
    data
  });
};

//模板下载
export const template = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: model + 'template/' + data.templateName,
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/auth/user/api/index.js